/**
 * Domaines 0 et 1 du MLD v5.0 — référentiels, acteurs, embarcations, engins.
 * Source : `db/migrations/001_init_schema.sql`.
 */
import { valeurs } from './enumeration.js';
// -----------------------------------------------------------------------------
// Référentiels pré-chargés (seeds de la migration 001)
// -----------------------------------------------------------------------------
/** `TYPE_PERSONNE.code` — rôles professionnels, cumulables et datés (★N02). */
export const CODE_TYPE_PERSONNE = {
    PROPRIETAIRE: 'PROPRIETAIRE',
    ARMATEUR: 'ARMATEUR',
    AFFRETAIRE: 'AFFRETAIRE',
    AFFRETEUR: 'AFFRETEUR',
    SUBRECARGUE: 'SUBRECARGUE',
    DEMANDEUR: 'DEMANDEUR',
    CAPITAINE: 'CAPITAINE',
    MARIN: 'MARIN',
    CONSIGNATAIRE: 'CONSIGNATAIRE',
};
export const CODES_TYPE_PERSONNE = valeurs(CODE_TYPE_PERSONNE);
/**
 * `TYPE_AUTORISATION.code` — les 14 types pré-chargés.
 * Référentiel ouvert par construction : d'autres types peuvent être ajoutés en
 * base par les directions métier sans migration (cf. docs/ETAT_PROJET.md).
 */
export const CODE_TYPE_AUTORISATION = {
    ACCES_RESSOURCE: 'ACCES_RESSOURCE',
    PECHE_HAUTE_MER: 'PECHE_HAUTE_MER',
    TRANSBORDEMENT: 'TRANSBORDEMENT',
    DEBARQUEMENT: 'DEBARQUEMENT',
    SORTIE_ZEE: 'SORTIE_ZEE',
    ENTREE_ZEE: 'ENTREE_ZEE',
    ENTREE_PORT: 'ENTREE_PORT',
    ACHAT_NAVIRE: 'ACHAT_NAVIRE',
    MODIFICATION_NAVIRE: 'MODIFICATION_NAVIRE',
    CONSTRUCTION_NAVIRE: 'CONSTRUCTION_NAVIRE',
    EMBARQUEMENT: 'EMBARQUEMENT',
    LICENCE_ZEE: 'LICENCE_ZEE',
    LICENCE_HAUTE_MER: 'LICENCE_HAUTE_MER',
    PERMIS_ARTISANAL: 'PERMIS_ARTISANAL',
};
export const CODES_TYPE_AUTORISATION = valeurs(CODE_TYPE_AUTORISATION);
/** `TYPE_ENGIN.code` (★N11). */
export const CODE_TYPE_ENGIN = {
    FILET: 'FILET',
    CHALUT: 'CHALUT',
    LIGNE: 'LIGNE',
    PALANGRE: 'PALANGRE',
    NASSE: 'NASSE',
    SENNE: 'SENNE',
    AUTRE: 'AUTRE',
};
export const CODES_TYPE_ENGIN = valeurs(CODE_TYPE_ENGIN);
/**
 * `ADMINISTRATION.sigle` — les 10 administrations du circuit d'instruction,
 * dans l'ordre de `ordre_dans_circuit` (★N05).
 */
export const SIGLE_ADMINISTRATION = {
    CABINET: 'CABINET',
    CNSP: 'CNSP',
    ONSPA: 'ONSPA',
    DEM: 'DEM',
    DNAP: 'DNAP',
    DIR_RECH: 'DIR_RECH',
    CNSHB: 'CNSHB',
    DNPC: 'DNPC',
    DNPM: 'DNPM',
    MINISTRE: 'MINISTRE',
};
export const SIGLES_ADMINISTRATION = valeurs(SIGLE_ADMINISTRATION);
// -----------------------------------------------------------------------------
// TYPE_AUTORISATION
// -----------------------------------------------------------------------------
/** `TYPE_AUTORISATION.document_produit` — nature du titre délivré en sortie. */
export const DOCUMENT_PRODUIT = {
    LICENCE: 'licence',
    PERMIS: 'permis',
    DOCUMENT: 'document',
    AUCUN: 'aucun',
};
export const DOCUMENTS_PRODUITS = valeurs(DOCUMENT_PRODUIT);
// -----------------------------------------------------------------------------
// PROFESSIONNEL_PECHE
// -----------------------------------------------------------------------------
/** `PROFESSIONNEL_PECHE.categorie` (★N01). */
export const CATEGORIE_PROFESSIONNEL = {
    PHYSIQUE: 'physique',
    MORALE: 'morale',
};
export const CATEGORIES_PROFESSIONNEL = valeurs(CATEGORIE_PROFESSIONNEL);
/** `PROFESSIONNEL_PECHE.type_piece_identite` (★N01). */
export const TYPE_PIECE_IDENTITE = {
    CNI: 'cni',
    PASSEPORT: 'passeport',
    CARTE_SEJOUR: 'carte_sejour',
    CARTE_MARIN: 'carte_marin',
    AUTRE: 'autre',
};
export const TYPES_PIECE_IDENTITE = valeurs(TYPE_PIECE_IDENTITE);
/** `PROFESSIONNEL_PECHE.statut` — identique à `EMBARCATION.statut`. */
export const STATUT_PROFESSIONNEL = {
    ACTIF: 'actif',
    SUSPENDU: 'suspendu',
    RADIE: 'radie',
};
export const STATUTS_PROFESSIONNEL = valeurs(STATUT_PROFESSIONNEL);
// -----------------------------------------------------------------------------
// EMBARCATION
// -----------------------------------------------------------------------------
/** `EMBARCATION.categorie` — discriminant de l'unification navire/pirogue (★N06). */
export const CATEGORIE_EMBARCATION = {
    NAVIRE: 'navire',
    PIROGUE: 'pirogue',
};
export const CATEGORIES_EMBARCATION = valeurs(CATEGORIE_EMBARCATION);
/** `EMBARCATION.statut`. */
export const STATUT_EMBARCATION = {
    ACTIF: 'actif',
    SUSPENDU: 'suspendu',
    RADIE: 'radie',
};
export const STATUTS_EMBARCATION = valeurs(STATUT_EMBARCATION);
// -----------------------------------------------------------------------------
// JOURNAL_PECHE
// -----------------------------------------------------------------------------
/** `JOURNAL_PECHE.statut`. */
export const STATUT_JOURNAL_PECHE = {
    OUVERT: 'ouvert',
    CLOTURE: 'cloture',
    VALIDE: 'valide',
};
export const STATUTS_JOURNAL_PECHE = valeurs(STATUT_JOURNAL_PECHE);
//# sourceMappingURL=metier.js.map